module.exports = __webpack_public_path__ + "img/dpIcon.5488d3c9.png";